import { Link } from 'react-router-dom';
import { TYPE_LABELS } from '../data/catalog';
import { getThumbnailUrl } from '../utils/media';
import { useThumbnailAuth } from '../hooks/useThumbnailAuth';

export default function ContentCard({ content }) {
  const label = TYPE_LABELS[content.type] || content.type;
  const thumbAuth = useThumbnailAuth();
  const thumb = getThumbnailUrl(content.media_url, content.thumbnail_key, thumbAuth);

  return (
    <Link to={`/content/${content.id}`} className="content-card">
      <div className="content-card-thumb">
        {thumb || content.media_url ? (
          <img src={thumb || content.media_url} alt={content.title} loading="lazy" />
        ) : (
          <div className="content-card-placeholder">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#bbb" strokeWidth="1.5">
              <polygon points="5,3 19,12 5,21" />
            </svg>
            <span>{label}</span>
          </div>
        )}
      </div>
      <div className="content-card-info">
        <h3>{content.title}</h3>
        <div className="content-card-meta">
          <span className="content-card-creator">{content.creator || label}</span>
          <span className="content-card-price">{parseFloat(parseFloat(content.price_usdc).toFixed(2))} $</span>
        </div>
      </div>
    </Link>
  );
}
